import * as Yup from 'yup';
import { DURATION_REGEX } from './formats';


export const DURATION_SCHEMA = Yup.string()
  .matches(DURATION_REGEX, 'Use o formato "1d 2h 30m" para dias, horas e minutos.')
  .required('Este campo é obrigatório');